// @flow @format
import {put, take, select} from 'redux-saga/effects';
import {PrivateApi} from 'lib/cloner-api';
import {
	addMachines,
	requestMachines,
	FETCH_MACHINES,
} from '../reducers/entities/machines';

import type {Machine} from 'lib/cloner-api';
import type {State} from '../reducers';
import type {FetchMachinesAction} from '../reducers/entities/machines';

function makeSaga(api: PrivateApi) {
	return function*(): Generator<*, void, *> {
		while (true) {
			const action: FetchMachinesAction = yield take(FETCH_MACHINES);
			const state: State = yield select();

			if (
				state.entities.machines.byUser[action.userId] ||
				state.entities.machines.entitiesFetching[action.userId]
			) {
				continue;
			}

			yield put(requestMachines(action.userId));

			try {
				const machines: Machine[] = yield api.getMachinesByUser(
					action.userId,
				);
				yield put(addMachines(action.userId, machines || []));
			} catch (error) {
				console.error(error);
			}
		}
	};
}

export default makeSaga;



// WEBPACK FOOTER //
// ./src/sagas/machines.js